export const PWD_USER = '$2a$10$bib.O4mrZMLb5wRhZl321ufozhHB7M926RNjdYvr2j8mEekOZYJyO';